import {Component} from '@angular/core';
import {AutoUnsubscribe} from 'src/infrastructure/decorators/auto-unsubscribe.decorator';
import {GenericChartComponent} from '../generic-chart/generic-chart.component';
import {FinanceDashboardChartType} from '../../enum/FinanceDashboardChartType';
import {TravelTypePieChartColorOptionsArray} from '../../constants/finance-dashboard-chart-options';

@Component({
    selector: 'app-commission-by-travel-type',
    templateUrl: './commission-by-travel-type.component.html',
    standalone: false
})

@AutoUnsubscribe()
export class CommissionByTravelTypeComponent extends GenericChartComponent {
  constructor() {
    super();
    this.chartConfiguration = {
      title: 'Commission by Travel Type',
      chartType: FinanceDashboardChartType.Pie,
      backGroundColor: TravelTypePieChartColorOptionsArray,
      borderColor: TravelTypePieChartColorOptionsArray,
    };
  }
}
 